import ItemIcon from './ItemIcon';
import ItemText from './ItemText';
import { Button } from './Button';
import { Tooltip, TooltipContent, TooltipTrigger } from './Tooltip/Tooltip';
import { useSubMenu } from '../SubMenuContext';
import { motion } from 'framer-motion';
import DashIconOutline from './appsIcons/DashIconOutline';
import DashArea from '../DashArea/DashArea';
import { Drawer, DrawerTrigger } from './Drawer';
import { EmpreenderApps } from '../lib/AppsArray';
import { eplusHub } from '../api/eplus';
import { useState } from 'react';

const ButtonDash = () => {
    const { isSidebarOpen, app, appEndPoint: endpoint, headers } = useSubMenu();
    const [iframeSrc, setIframeSrc] = useState<string | null>(null);

    const appEntry = EmpreenderApps.find((a) =>
        a.tags.some((tag) => tag?.toLowerCase() === app?.toLowerCase())
    );

    const handleOpen = async () => {
        if (!appEntry) return;

        setIframeSrc(null);

        const { slug } = appEntry;

        const res = await eplusHub({
            method: "POST",
            credentials: "include" as RequestCredentials,
            headers,
            body: JSON.stringify({
                acao: "buscarLinkDeLoginDash",
                redirect_back: `/relatorios?template_name=${slug}&iframe=true`,
            }),
        }, endpoint);

        const url = res?.data?.link ?? `https://app.dash.com.br/relatorios?template_name=${slug}&iframe=true`;
        if (url) setIframeSrc(url);
    };

    return (
        <Drawer>
            <Tooltip>
                <TooltipTrigger asChild>
                    <Button asChild variant={'secondary'} className='group cursor-pointer rounded-lg text-sm font-medium items-center justify-between break-normal whitespace-nowrap gap-[6px] h-9 w-full min-w-9 flex flex-row px-3 py-2 transition focus-visible:outline-0 overflow-hidden bg-white text-gray-900 hover:!bg-gray-100 hover:opacity-100'>
                        <DrawerTrigger asChild onClick={handleOpen}>
                            <motion.button
                                initial={{ paddingLeft: isSidebarOpen ? 12 : 10 }}
                                transition={{ duration: 0.2 }}
                                animate={{ paddingLeft: isSidebarOpen ? 12 : 10 }}>
                                <ItemIcon>
                                    <div className='relative'>
                                        <div className='!m-0 absolute z-[1] top-2/4 left-2/4 -translate-y-2/4 -translate-x-2/4 h-[calc(100%-3px)] w-[calc(100%-3px)] rounded-full flex items-center justify-center'>
                                            <DashIconOutline />
                                        </div>
                                    </div>
                                </ItemIcon>
                                <ItemText>Dash Analytics</ItemText>
                            </motion.button>
                        </DrawerTrigger>
                    </Button>
                </TooltipTrigger>
                {!isSidebarOpen ? (
                    <TooltipContent sideOffset={10} side='right'>Dash</TooltipContent>
                ) : (
                    <></>
                )}
            </Tooltip>

            <DashArea iframeSrc={iframeSrc} />
        </Drawer>
    );
};

export default ButtonDash;